import { TemplateUtenteProfilo } from './template-utente-profilo';
import { UtenteProfilo } from './utente-profilo';

export class UtenteProfiloTemplate {
  utente: UtenteProfilo;
  templateProfilo: TemplateUtenteProfilo;

  constructor(utente: UtenteProfilo, templateProfilo: TemplateUtenteProfilo) {
    this.utente = utente;
    this.templateProfilo = templateProfilo;
  };

}
